import { Link } from 'react-router-dom'
import { NextPageIcon, RightButton } from './navigation.styled'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import {
  FairtradeNavLabel,
  FairtradeNextPageIcon,
  FairtradeRightButton,
} from 'src/templates/fairtrade/navigation/fairtrade-nav-buttons.styled'

type NextPageProps = {
  to: string
  state?: object
  isImpactPage?: boolean
  isTopDivider?: boolean
  topOffset?: number
  label?: string
  variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
  backgroundColor?: string
  textColor?: string
}

export const NextPage = ({
  isImpactPage,
  isTopDivider,
  to,
  state,
  topOffset,
  label,
  variant = 'default',
  backgroundColor,
  textColor,
}: NextPageProps) => {
  const isFairtradeVariant = variant === JOURNEY_PAGE_TEMPLATE_ID.FAIRTRADE

  return (
    <Link to={to} state={state ?? null}>
      {isFairtradeVariant ? (
        <FairtradeRightButton
          id="next-page-component__components-navigation__fairtraderightbutton__l38"
          size="medium"
          aria-label="Next Page"
          isImpactPage={isImpactPage}
          isTopDivider={isTopDivider}
          topOffset={topOffset}
          backgroundColor={backgroundColor}
          textColor={textColor}
        >
          {label && (
            <FairtradeNavLabel id="next-page-component__components-navigation__fairtradenavlabel__l48">
              {label}
            </FairtradeNavLabel>
          )}
          <FairtradeNextPageIcon id="next-page-component__components-navigation__fairtradenextpageicon__l52" />
        </FairtradeRightButton>
      ) : (
        <RightButton
          id="next-page-component__components-navigation__rightbutton__l14"
          size="medium"
          aria-label="Next Page"
          isImpactPage={isImpactPage}
          isTopDivider={isTopDivider}
          topOffset={topOffset}
        >
          <NextPageIcon id="next-page-component__components-navigation__nextpageicon__l20" />
        </RightButton>
      )}
    </Link>
  )
}
